// Module
var code = "<qualities></qualities>\n";
// Exports
module.exports = code;